import { useEffect, useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import frankimmo from "../../../images/LOGO.jpeg";

const Background = styled.header`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 110px;

    display: flex;
    justify-content: center;
    align-items: center;

    z-index: 1000;

    background: ${({ $scrolled }) =>
        $scrolled ? "rgba(255,255,255,0.97)" : "transparent"};

    backdrop-filter: ${({ $scrolled }) =>
        $scrolled ? "blur(12px)" : "none"};

    box-shadow: ${({ $scrolled }) =>
        $scrolled ? "0 5px 25px rgba(0,0,0,.08)" : "none"};

    transition: all .35s ease;
`;

const Content = styled.div`
    width: min(1300px, 92%);

    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const Interaction = styled.nav`
    display: flex;
    align-items: center;
`;

export const StyledLink = styled(Link)`
    position: relative;

    margin-left: 42px;
    text-decoration: none;

    color: ${({ $scrolled }) =>
        $scrolled ? "#222" : "white"};

    font-size: .92rem;
    font-weight: 400;
    letter-spacing: 2px;
    text-transform: uppercase;

    transition: color .3s ease;

    &::after{
        content:"";
        position:absolute;
        left:0;
        bottom:-8px;

        width:0%;
        height:1px;

        background: currentColor;

        transition: width .3s ease;
    }

    &:hover::after{
        width:100%;
    }

    @media(max-width:700px){
        margin-left:20px;
        font-size:.82rem;
        letter-spacing:1px;
    }
`;

const LogoLink = styled(Link)`
    display:flex;
    align-items:center;
`;

const Logo = styled.img`
    width: 92px;
    display:block;
    transition: transform .3s ease;

    &:hover{
        transform: scale(1.03);
    }

    @media(max-width:700px){
        width:74px;
    }
`;

function Header() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 40);
        };

        handleScroll();

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <Background $scrolled={scrolled}>
            <Content>
                <LogoLink to="/">
                    <Logo
                        src={frankimmo}
                        alt="Frank Immobilien"
                    />
                </LogoLink>

                <Interaction>
                    <StyledLink
                        to="/immobilien"
                        $scrolled={scrolled}
                    >
                        Immobilien
                    </StyledLink>
                </Interaction>
            </Content>
        </Background>
    );
}

export default Header;